import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchProductCategoryTree = createAsyncThunk("fetchProductCategoryTree", async ({ company }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`/productcategory/tree/list?company=${company}`, config);
	return response.data.data;
});

const ProductCategoryTreeSlice = createSlice({
	name: "ProductCategoryTreeSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchProductCategoryTree.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchProductCategoryTree.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.current_page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchProductCategoryTree.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ProductCategoryTreeSlice.reducer;
